import { ISelector } from '@omaze/redux';

import { IFeatureFlagMap } from '../../../interfaces/IFeatureFlagMap';
import { createFeatureFlagSelector } from '../../FeatureFlag.factory';
import { IFeatureFlagState } from '../../FeatureFlag.state';

export const selectFlags: ISelector<
IFeatureFlagState,
IFeatureFlagMap
> = createFeatureFlagSelector(
    (state: IFeatureFlagState): IFeatureFlagMap => {
        return state.flags;
    },
);
